import { sxAjax } from '@/commons/ajax';
export default {
    // 播放日志
    pageList: {
        payload: ({ params, options }) => sxAjax.get('/agent/log-manage/getProgramPlayLogCounts', params, options).then(function (resp) {
            return new Promise((resolve, reject) => {
                if (resp.code === 0) {
                    resolve(resp.data);
                } else {
                    reject(resp.msg);
                }
            });
        }),
        reducer: {
            pending: (state, action) => {
                return { loading: true };
            },
            resolve(state, { payload = {} }) {
            },
            complete: (state, action) => ({ loading: false }),
        }
    }
}